import axios from 'axios';

export const AxiosAPI = axios.create({
  // baseURL: 'http://localhost:8080/api',
  baseURL: process.env.REACT_APP_API_URL || 'https://air-forms-backend-369967495241.us-west1.run.app/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error) && error.response) {
      return error.response.data?.errors?.[0]?.detail || "An unknown server error occurred";
  } else if (error instanceof Error) {
      return error.message;
  } else {
      return "An unknown error occurred";
  }
};